<div class="email-notifications-container">
  <div class="notification-item" *ngFor="let notification of notificationFlags">
    <div class="permission-details">
      <span class="roles-title">{{ notification.label }}</span>
      <span class="roles-content">{{ notification.description }}</span>
    </div>
    <label class="switch">
      <input type="checkbox" [checked]="getNotificationValue(notification.key)"
        (change)="onToggleChange(notification.key, $any($event.target).checked)" />
      <span class="slider round"></span>
    </label>
  </div>
</div>